import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Hero from "@/components/Hero";
import ChiSiamoSection from "@/components/ChiSiamoSection";
import GammaActive from "@/components/GammaActive";
import ExperienceActive from "@/components/ExperienceActive";
import RecentlyViewed from "@/components/RecentlyViewed";
import VehicleGrid from "@/components/VehicleGrid";
import useSeo from "@/lib/useSeo";

export default function Home() {
  useSeo({
    title:
      "Scooter Cabinati e Auto Usate Garantite | Minicarmobilità Milano Sud",
    description:
      "Minicarmobilità a Zibido San Giacomo (MI). Vendita scooter cabinati elettrici e benzina, auto usate selezionate con garanzia 12 mesi. Test drive gratuito.",
  });
  return (
    <main data-testid="home-page" className="relative">
      <Header />
      <Hero />
      <ChiSiamoSection />
      <GammaActive />
      <ExperienceActive />
      <RecentlyViewed />
      <VehicleGrid />
      <Footer />
    </main>
  );
}
